import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { isBefore, startOfToday } from 'date-fns';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { AreaUser, SiteArea } from 'src/app/models/site-area.model';
import { convertTimestamp } from 'src/app/utility/time';

@Component({
  selector: 'app-renters-dialog',
  templateUrl: './renters.dialog.html',
  styleUrls: ['./renters.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
    NoResultsComponent,
  ],
})
export class RentersDialogComponent {
  private _modal = inject(ModalController);
  private navParams = inject(NavParams);

  empty = signal(true);

  private areas = this.navParams.get<SiteArea[]>('areas').map((area) => {
    area.users = area.users?.filter((it) => it.end == null || isBefore(startOfToday(), convertTimestamp(it.end)));
    if (area.users?.length > 0) {
      this.empty.set(false);
    }
    return area;
  });

  areasS = signal(this.areas);

  onItem(area: SiteArea, item?: AreaUser) {
    this._modal.dismiss({ area, item });
  }

  dismiss() {
    this._modal.dismiss();
  }
}
